import ROUTES from '~/shared/constants/routes.const'
import { isAuthenticated } from '~/auth/slices/auth.slice'

import { selectPreviewSite } from '~/redux/slices/ui'

import { useAppSelector } from '~/redux/hooks'

export function useHomeLink(): string {
  const previewSite = useAppSelector(selectPreviewSite)
  const authenticated = useAppSelector(isAuthenticated)
  return authenticated || previewSite ? ROUTES.DASHBOARD : ROUTES.HOME
}
